import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "./translations/en.json";
import fr from "./translations/fr.json";

const resources = {
  en: {
    translation: en
  },
  fr: {
    translation: fr
  }
};

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    compatibilityJSON: "v4",
    interpolation: {
      escapeValue: false
    },
    nsSeparator: false,
    keySeparator: false,
    supportedLngs: Object.keys(resources)
  });

export type Language = "en" | "fr";
